/**
 * Pick API client
 * Handles celebrity pick submission and retrieval
 */
import type { ApiResponse, Pick, PlayerPicks, SubmitPicksInput } from './types';
import { apiClient } from './client';

/**
 * Submit picks for a pool
 * @param poolId Pool identifier
 * @param input Pick submission data (15 picks with exactly one #1 pick)
 * @returns Submitted picks
 */
export async function submitPicks(
  poolId: string,
  input: SubmitPicksInput
): Promise<ApiResponse<Pick[]>> {
  return apiClient.post<Pick[]>(`/pools/${poolId}/picks`, input);
}

/**
 * Get the current user's picks for a pool
 * @param poolId Pool identifier
 * @returns User's picks
 */
export async function getMyPicks(
  poolId: string
): Promise<ApiResponse<Pick[]>> {
  return apiClient.get<Pick[]>(`/pools/${poolId}/picks`);
}

/**
 * Get all picks for a pool (only available after deadline)
 * @param poolId Pool identifier
 * @returns All players' picks grouped by user
 */
export async function getAllPicks(
  poolId: string
): Promise<ApiResponse<PlayerPicks[]>> {
  return apiClient.get<PlayerPicks[]>(`/pools/${poolId}/picks/all`);
}
